import { registerCustomControlProvider } from '../registry';
import { handleSvgColors } from '~src/svg-colors';
import {
  buildObjectActionsButtons,
  createColorSubview,
  attachColorPopulateHooks,
} from './shared';

const VECTOR_TYPES = new Set([
  'path',
  'rect',
  'circle',
  'ellipse',
  'polygon',
  'polyline',
  'line',
]);

function isVectorPrimitive(obj) {
  return !!(obj && VECTOR_TYPES.has(obj.type));
}

function getGroupChildren(obj) {
  if (!obj) return [];
  if (typeof obj.getObjects === 'function') return obj.getObjects();
  if (Array.isArray(obj._objects)) return obj._objects;
  return [];
}

export function isSvgLike(obj) {
  if (!obj) return false;
  if (isVectorPrimitive(obj)) return true;
  if (obj.type === 'group' || obj.type === 'activeSelection') {
    const children = getGroupChildren(obj);
    if (!children.length) return false;
    // Consider it SVG-like only if all children are vector primitives
    return children.every((ch) => isVectorPrimitive(ch));
  }
  return false;
}

registerCustomControlProvider({
  id: 'svg-floating-controls',
  match: (object) => isSvgLike(object),
  create: (manager, object) => {
    const options = {
      offsetY: 0,
      offsetX: 0,
      gap: 12,
      initialView: 'home',
      views: {
        home: { buttons: [] },
      },
    };

    // Attach shared color subview
    const { navigateButton, viewDef } = createColorSubview({
      viewId: 'svgColors',
      title: 'Colori SVG',
      containerClass: 'svg-colors',
      backTo: 'home',
      showBack: false,
    });
    options.views = { ...options.views, ...viewDef };
    options.views.home.buttons.push(navigateButton);

    // Attach shared object actions as hover submenu
    options.views.home.buttons.push({
      text: 'Azioni',
      inlineSvg:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"></path></svg>',
      className: 'btn-customize',
      children: buildObjectActionsButtons(() => object),
    });

    const ctrl = manager.createFloatingControls(object, options);
    attachColorPopulateHooks(ctrl, 'svgColors', () => handleSvgColors());
    return ctrl;
  },
});
